import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ProblemActionBody from "./ProblemActionBody";
import ProblemDescriptionMobile from "./ProblemDescriptionMobile";
import { rowsPerPageOptions } from "../../utils/problemConstants";
import {
  isProblemSolved,
  kendaraanCompactBodyTemplate,
  problemBodyTemplate,
  statusBodyTemplate,
  tanggalDurasiBodyTemplate,
} from "../../utils/problemTemplates";

// small paginator for mobile: buttons of 2rem instead of 3rem, small text
const mobilePaginatorClassName =
  "w-100 !px-0 !py-1 !gap-1 [&_.p-paginator-element]:!min-w-[2rem] [&_.p-paginator-element]:!h-[2rem] [&_.p-paginator-current]:!min-w-0 [&_.p-paginator-current]:!h-[2rem] [&_.p-paginator-current]:!text-xs";

// light list look (desktop): no gridlines, a soft header, every row is one problem
const listClassName = [
  "w-100",
  "[&_.p-datatable-thead>tr>th]:!bg-slate-50",
  "[&_.p-datatable-thead>tr>th]:!text-xs",
  "[&_.p-datatable-thead>tr>th]:!uppercase",
  "[&_.p-datatable-thead>tr>th]:!tracking-wide",
  "[&_.p-datatable-thead>tr>th]:!text-slate-500",
  "[&_.p-datatable-thead>tr>th]:!border-x-0",
  "[&_.p-datatable-tbody>tr>td]:!border-x-0",
  "[&_.p-datatable-tbody>tr>td]:!align-top",
  "[&_.p-datatable-tbody>tr>td]:!py-3",
].join(" ");

// One card with a table of problems (the list of the active status tab).
//   sortable / formatLabelGrup: what differs between problem kendaraan and problem trado
//   sortable: { no, description } columns that can be sorted
//   paging: { first, rows } of the table (local paging), onPage: called by the paginator of the table
//   handlers: { permittedToEdit, onEdit, onDelete, onClickImage, onClickShowPengecekan }
const ProblemTableCard = ({
  title,
  value,
  selection,
  setSelection,
  loading,
  paging,
  onPage,
  isMobile,
  sortable,
  formatLabelGrup,
  handlers,
}) => {
  const groupText = (row) =>
    row.label_grup && row.label_grup.length > 0
      ? formatLabelGrup(row.label_grup)
      : "";

  const problemTemplate = (row) => problemBodyTemplate(row, groupText(row));

  const actionBodyTemplate = (row) => (
    <ProblemActionBody row={row} {...handlers} />
  );

  const descriptionMobileBodyTemplate = (rowData) => (
    <ProblemDescriptionMobile
      rowData={rowData}
      formatLabelGrup={formatLabelGrup}
      {...handlers}
    />
  );

  return (
    <div className="col-center-center w-100 gap-3">
      <div className="row-between-center gap-2 w-100">
        <div className="row-start-center gap-2">
          <span className="text-sm font-semibold text-zinc-700">{title}</span>
          <span className="rounded-full bg-slate-100 px-2 py-0.5 text-xs font-semibold text-slate-500">
            {value.length}
          </span>
        </div>
      </div>

      <div className="row-center-center gap-2 w-100">
        <DataTable
          dataKey="id"
          className={listClassName}
          loading={loading}
          emptyMessage="Tidak ada problem"
          value={value}
          paginator
          first={paging.first}
          rows={paging.rows}
          onPage={onPage}
          paginatorClassName={isMobile ? mobilePaginatorClassName : ""}
          // mobile: small, no page numbers and no rows per page, only "< 1 / 3 (25) >"
          {...(isMobile
            ? {
                paginatorTemplate: "PrevPageLink CurrentPageReport NextPageLink",
                currentPageReportTemplate:
                  "{currentPage} / {totalPages} ({totalRecords})",
                showGridlines: true,
                stripedRows: true,
              }
            : { rowsPerPageOptions })}
          selection={selection}
          onSelectionChange={(e) => setSelection(e.value)}
          rowClassName={(data) =>
            isProblemSolved(data) ? "bg-green-50" : "bg-white"
          }
        >
          {/* mobile: one DESKRIPSI column holds the whole problem */}
          {isMobile && (
            <Column
              sortable={sortable.description}
              header="DESKRIPSI"
              headerClassName="text-xs"
              className="!p-0"
              alignHeader={"left"}
              body={descriptionMobileBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              header="#"
              field="no"
              headerClassName="w-[3rem]"
              className="text-right text-slate-400"
              alignHeader={"right"}
            />
          )}

          {!isMobile && (
            <Column
              field="data_kendaraan.nomor_polisi"
              header="Kendaraan"
              headerClassName="w-[9rem]"
              body={kendaraanCompactBodyTemplate}
            />
          )}

          {/* takes all the width that is left */}
          {!isMobile && (
            <Column
              field="label_grup"
              header="Problem"
              body={problemTemplate}
            />
          )}

          {!isMobile && (
            <Column
              field="tanggal"
              header="Tanggal"
              headerClassName="w-[9.5rem]"
              body={tanggalDurasiBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              field="di_tangani_id"
              header="Status"
              headerClassName="w-[15rem]"
              body={statusBodyTemplate}
            />
          )}

          {!isMobile && (
            <Column
              header="Action"
              alignHeader={"center"}
              headerClassName="w-[8rem]"
              body={actionBodyTemplate}
            />
          )}
        </DataTable>
      </div>
    </div>
  );
};

export default ProblemTableCard;
